import React from 'react';

const TeamSection = () => {
  const teamMembers = [
    {
      name: 'Jae',
      role: 'CEO / 창업자',
      bio: 'Full-Stack Developer로서 AI/자동화 기반 서비스 구축 전문가. 기획부터 개발, 배포, 운영까지 전 과정을 책임집니다.',
      quote: '"만드는 것"에서 끝나지 않고, "돌아가게 만드는 것"까지 책임집니다.',
      image: '/image/jae.png',
    },
    {
      name: 'Anna',
      role: '브랜드 디렉터',
      bio: 'Creative Brand Director & Business Architect. 브랜드 경험 디자인과 신규 사업 설계를 담당합니다.',
      quote: 'Brands don\'t grow by chance. They grow by structure.',
      image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=200&h=200&auto=format&fit=crop',
    },
    {
      name: 'JT',
      role: 'Full Stack 개발자',
      bio: '웹과 모바일을 아우르는 Full Stack 개발자. 사용자 경험을 최우선으로 생각하며 안정적이고 확장 가능한 서비스를 구축합니다.',
      quote: '좋은 코드는 문제를 해결하고, 훌륭한 코드는 문제가 생기지 않게 합니다.',
      image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?q=80&w=200&h=200&auto=format&fit=crop',
    },
  ];

  return (
    <section id="team" className="py-20 bg-light">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="inline-block px-3 py-1 bg-primary/10 text-primary rounded-full text-sm font-medium mb-4">
            팀 소개
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-dark mb-4">
            <span className="text-primary">전문가</span>들이 모인 GenAI Dev 팀
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            AI 기술과 비즈니스 혁신에 대한 열정을 가진 전문가들이 모여 Generative AI의 미래를 만들어갑니다.
            다양한 배경과 전문성을 바탕으로 창의적인 솔루션을 개발하고 있습니다.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {teamMembers.map((member, index) => (
            <div key={index} className="bg-white rounded-xl shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-2">
              <div className="relative overflow-hidden rounded-t-xl">
                <img 
                  src={member.image} 
                  alt={member.name} 
                  className="w-full h-64 object-cover object-center"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 hover:opacity-100 transition-opacity flex items-end p-6">
                  <p className="text-white text-sm italic">"{member.quote}"</p>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-dark mb-1">{member.name}</h3>
                <p className="text-primary font-medium mb-3">{member.role}</p>
                <p className="text-gray-600 text-sm">{member.bio}</p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-16 bg-white p-8 rounded-xl shadow-md">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold text-dark mb-4">
              우리와 함께 <span className="text-primary">미래를 만들어갈</span> 인재를 찾습니다
            </h3>
            <p className="text-gray-600 max-w-2xl mx-auto mb-6">
              GenAI Dev는 AI 기술의 가능성을 믿고, 함께 성장하며 혁신을 이끌어갈 열정적인 인재를 항상 환영합니다.
              다양한 배경과 아이디어가 모여 더 나은 AI 솔루션을 만들어 갑니다.
            </p>
            <a 
              href="#contact" 
              className="inline-block bg-primary text-white px-6 py-3 rounded-md font-medium hover:bg-primary/90 transition-colors"
            >
              채용 문의하기
            </a>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            <div className="border border-gray-200 rounded-lg p-4 flex items-start">
              <div className="w-10 h-10 bg-primary/10 rounded flex items-center justify-center mr-4 flex-shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <div>
                <h4 className="font-bold text-dark mb-1">도전적인 업무</h4>
                <p className="text-gray-600 text-sm">
                  최첨단 AI 기술을 활용한 혁신적인 프로젝트에 참여할 기회
                </p>
              </div>
            </div>
            
            <div className="border border-gray-200 rounded-lg p-4 flex items-start">
              <div className="w-10 h-10 bg-primary/10 rounded flex items-center justify-center mr-4 flex-shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                </svg>
              </div>
              <div>
                <h4 className="font-bold text-dark mb-1">성장 기회</h4>
                <p className="text-gray-600 text-sm">
                  지속적인 학습과 개발을 장려하는 환경과 다양한 교육 지원
                </p>
              </div>
            </div>
            
            <div className="border border-gray-200 rounded-lg p-4 flex items-start">
              <div className="w-10 h-10 bg-primary/10 rounded flex items-center justify-center mr-4 flex-shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <div>
                <h4 className="font-bold text-dark mb-1">협력적 문화</h4>
                <p className="text-gray-600 text-sm">
                  다양한 아이디어를 존중하고 팀워크를 중시하는 열린 환경
                </p>
              </div>
            </div>
            
            <div className="border border-gray-200 rounded-lg p-4 flex items-start">
              <div className="w-10 h-10 bg-primary/10 rounded flex items-center justify-center mr-4 flex-shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <h4 className="font-bold text-dark mb-1">유연한 근무</h4>
                <p className="text-gray-600 text-sm">
                  일과 삶의 균형을 존중하는 유연한 근무 환경 제공
                </p>
              </div>
            </div>
            
            <div className="border border-gray-200 rounded-lg p-4 flex items-start">
              <div className="w-10 h-10 bg-primary/10 rounded flex items-center justify-center mr-4 flex-shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <div>
                <h4 className="font-bold text-dark mb-1">윤리적 AI</h4>
                <p className="text-gray-600 text-sm">
                  윤리적 AI 개발을 통해 사회에 긍정적인 영향을 미치는 일
                </p>
              </div>
            </div>
            
            <div className="border border-gray-200 rounded-lg p-4 flex items-start">
              <div className="w-10 h-10 bg-primary/10 rounded flex items-center justify-center mr-4 flex-shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <h4 className="font-bold text-dark mb-1">경쟁력 있는 보상</h4>
                <p className="text-gray-600 text-sm">
                  능력과 성과에 따른 공정한 보상 체계 및 다양한 복리후생
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamSection; 